import { defineMessages } from 'react-intl';

export const i18n: {
	documentStatusFilterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	documentStatusFilterNoOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	documentStatusFilterLabel: {
		id: 'search-page.salesforce.filter.documentStatus',
		defaultMessage: 'Document status',
		description: 'Label for filtering by Salesforce knowledge article (document) status',
	},
	documentStatusFilterNoOptions: {
		id: 'search-page.salesforce.filter.documentStatus.no-options',
		defaultMessage: 'No statuses available',
		description:
			'Message shown in the Salesforce document status filter dropdown when no status options are available',
	},
});
